import * as React from 'react'
import * as ReactDOM from 'react-dom'

import NavBar from './AppNavBar'
import HelpMenu from '../components/HelpMenu/HelpMenu'

import PortalPool, {
  ROOT_POOL_ID,
} from 'airship/components/RactivePortal/PortalPool'

type Module = () => void | React.ReactElement

const Wrapper: React.FC<{m: Module}> = ({m}) => {
  const instance = m()
  if (
    instance &&
    (React.isValidElement(instance) || isReactElement(instance))
  ) {
    return instance
  }
  return <></>
}

export default function loadApp(modules: Module[]): void {
  ReactDOM.render(
    <>
      {modules.map((module, idx) => {
        return <Wrapper m={module} key={idx} />
      })}
      <PortalPool poolId={ROOT_POOL_ID} />
    </>,
    document.getElementById('airship-react-root')
  )
  const globalNavBarContainer = document.querySelector(
    '[data-testid="global-navbar-container"]'
  )
  const helpMenu = document.querySelector('[data-testid="help-menu"]')
  if (globalNavBarContainer) {
    ReactDOM.render(<NavBar />, globalNavBarContainer)
  }
  if (helpMenu) {
    ReactDOM.render(<HelpMenu />, helpMenu)
  }
}

function isReactElement(obj: unknown): obj is React.ReactElement {
  return (
    Object.prototype.hasOwnProperty.call(obj, 'children') &&
    Object.prototype.hasOwnProperty.call(obj, 'containerInfo')
  )
}
